import React, { useRef } from 'react';

// Styles & Assets
import clipSvg from '../../../assets/icons/clip.svg';

// Interfaces
interface Props {
    acceptedFormats: string[]
    handleUploadFile: (file: File) => void
}

const FileUpload: React.FC<Props> = ({ acceptedFormats, handleUploadFile }) => {

    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleOpenFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) handleUploadFile(file);
        event.target.value = '';
    };

    return (
        <>
            <button type='button' style={{ transform: 'rotateZ(45deg)' }} onClick={handleOpenFile}>
                <img src={clipSvg} alt="" />
            </button>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept={acceptedFormats.join(', ')}
            />
        </>
    );
};

export default FileUpload;